export default __webpack_public_path__ + "static/oleg-f123714deea7df53c704ecf7149cce5e.png";